export default "__VITE_ASSET__C63I9WI0__"